import { Component, OnInit, QueryList, Input, ContentChildren } from '@angular/core';
import { AccordionPanelComponent } from './accordion-panel/accordion-panel.component';

@Component({
    selector: 'accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent {
    @Input()
    allowMultiplePanels: boolean = true;

    @ContentChildren(AccordionPanelComponent)
    public _panels: QueryList<AccordionPanelComponent>;

    constructor() {
    }

    ngAfterViewInit() {
        this._panels.forEach(x => {
            x.openChange.subscribe(() => {
                this.panelOpened(x);
            });
        });

        this._panels.changes.subscribe((result: QueryList<AccordionPanelComponent>) => {
            result.filter(x => !this._panels.find(y => y === x)).forEach(x => {
                x.openChange.subscribe(() => {
                    this.panelOpened(x);
                });
            });
        });
    }

    public panelOpened(panel: AccordionPanelComponent) {
        if (this.allowMultiplePanels)
            return;

        this._panels.forEach(x => {
            if (x !== panel)
                x.closePanel();
        });
    }
}
